(function(){
  var MAP = {36:{w:"6-6.5",m:"4.5",uk:"3.5"},37:{w:"7",m:"5",uk:"4"},38:{w:"7.5-8",m:"5.5-6",uk:"5"},
    39:{w:"8.5",m:"6.5",uk:"5.5"},40:{w:"9-9.5",m:"7-7.5",uk:"6.5"},41:{w:"10",m:"8",uk:"7.5"},
    42:{w:"10.5-11",m:"8.5-9",uk:"8"},43:{w:"11.5-12",m:"9.5-10",uk:"9"},44:{w:"12.5",m:"10.5",uk:"9.5"},
    45:{w:"13-13.5",m:"11-11.5",uk:"10.5"},46:{w:"14",m:"12",uk:"11"},47:{w:"14.5-15",m:"12.5-13",uk:"12"},
    48:{w:"15.5-16",m:"13.5-14",uk:"13"}};
  function init(){
    var box=document.querySelector('[data-bal-units]');
    if(!box||box.dataset.ready)return;
    var scope=box.closest('form')||box.closest('.product-info')||document;
    var nodes=[];
    scope.querySelectorAll('label,span,button').forEach(function(el){
      if(el.children.length)return;
      var t=(el.textContent||'').trim();
      var m=t.match(/^(?:EU\s*)?(3[6-9]|4[0-8])$/i);
      if(m){ if(!el.dataset.eu) el.dataset.eu=m[1]; nodes.push(el); }
    });
    if(!nodes.length)return;
    box.dataset.ready="1";
    box.querySelectorAll('button[data-u]').forEach(function(b){
      b.addEventListener('click',function(){
        box.querySelectorAll('button[data-u]').forEach(function(x){x.classList.remove('is-on')});
        b.classList.add('is-on');
        var u=b.dataset.u;
        nodes.forEach(function(el){
          var eu=el.dataset.eu, r=MAP[eu];
          el.textContent = (u==='eu'||!r) ? ('EU '+eu) : (u==='uk' ? ('UK '+r.uk) : ((u==='w'?'W ':'M ')+r[u]));
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded',init);
  init();
  new MutationObserver(init).observe(document.documentElement,{childList:true,subtree:true});
})();


/* Zet de maat-eenheid schakelaar OP DEZELFDE REGEL als het kopje "Size" van
   de variant-kiezer. Als los blok staat hij anders boven "Color" en zie je
   het woord Size twee keer. */
(function(){
  function place(){
    var box=document.querySelector('[data-bal-units]');
    var vp=document.querySelector('variant-picker');
    if(!box||!vp) return;
    var doel=null;
    vp.querySelectorAll('.variant-picker__option').forEach(function(fs){
      var lab=fs.querySelector('legend,.variant-picker__option-name,label');
      var t=lab?(lab.textContent||'').trim().toLowerCase():'';
      if(!doel && t.indexOf('size')===0) doel=fs;
    });
    if(!doel) return;
    var rij=doel.querySelector('.variant-picker__option-info')||doel;
    if(box.previousElementSibling!==rij){
      rij.insertAdjacentElement('afterend',box);
      box.classList.add('bal-units--inline');
    }
  }
  document.addEventListener('DOMContentLoaded',place);
  place();
  new MutationObserver(place).observe(document.documentElement,{childList:true,subtree:true});
})();
/* Bezorgdatum: 5 tot 9 werkdagen vanaf vandaag, zoals Bearefoot doet. */
(function(){
  function werkdagen(n){
    var d=new Date();
    while(n>0){ d.setDate(d.getDate()+1); if(d.getDay()!==0 && d.getDay()!==6) n--; }
    return d;
  }
  function fmt(d){
    var m=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var n=d.getDate(), s='th';
    if(n%10===1&&n!==11)s='st'; else if(n%10===2&&n!==12)s='nd'; else if(n%10===3&&n!==13)s='rd';
    return m[d.getMonth()]+' '+n+s;
  }
  function vul(){
    document.querySelectorAll('[data-bf-deliv]').forEach(function(el){
      if(el.dataset.klaar) return;
      el.textContent=fmt(werkdagen(5))+' - '+fmt(werkdagen(9));
      el.dataset.klaar='1';
    });
  }
  document.addEventListener('DOMContentLoaded',vul); vul();
  new MutationObserver(vul).observe(document.documentElement,{childList:true,subtree:true});
})();